<template>
  <span>
    {{ workflowLabel }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { WORKFLOWS } from "@/helpers/constants";

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
});

const workflowLabel = computed(() => {
  const workflowType =
    (Object.keys(WORKFLOWS) as Array<keyof typeof WORKFLOWS>).find(
      (workflow) => props.model[workflow]
    ) || "is_funding";
  return WORKFLOWS[workflowType];
});
</script>
